import { AxiosError } from 'axios';

import {
    Payload,
    UnauthorizedException,
} from 'app/api/exception/UnauthorizedException';
import { Interceptor } from 'app/api/interceptor/Interceptor';

export class UnauthorizedErrorInterceptor implements Interceptor {
    process(error: AxiosError): void {
        if (error.response.status === 401) {
            const payload = error.response.data;

            throw new UnauthorizedException(payload as Blob | Payload);
        }
    }
}
